import $ from 'jquery';
import config from '../config';
const URL_API = config.urlApi+'controllers/getLastMonth.controller.php';

export default function getMonthVisits(values){
    return $.ajax({
        data: values,
        url: URL_API,
        type: 'GET'
    })
}